var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.333,
    cy: 30,
    r: 17,
    fill: "#F182AD",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0003 21.3334C21.0003 21.3334 20.5787 20.1143 20.5039 18.3036C20.4555 17.1337 20.5519 15.7168 21.0003 14.2222C22.607 8.86664 25.5044 6.09244 27.5539 4.73317C28.602 4.03808 29.8097 4.9256 29.9344 6.17704C30.1596 8.43753 30.9451 11.7225 33.4448 14.2222C33.6988 14.4762 34.0253 14.7665 34.3985 15.0982C36.6376 17.0885 40.556 20.5715 40.556 26.6668C40.556 33.778 33.8939 39.1113 26.3337 39.1113C18.7735 39.1113 12.1113 33.778 12.1113 24.889C12.1113 21.8722 13.2046 17.828 14.1787 14.8233C14.6725 13.3002 16.6993 13.2869 17.2611 14.7863C17.6515 15.8281 18.0408 16.8994 18.3336 17.7778C19.2225 20.4445 21.0003 21.3334 21.0003 21.3334ZM20.2052 22.9235C20.8516 23.2467 21.6293 23.1465 22.1726 22.6699C22.7138 22.1952 22.9151 21.4411 22.6831 20.7601L22.68 20.7507C22.6516 20.6623 22.4474 19.9989 22.3391 19.0119C22.2145 17.8753 22.2184 16.3486 22.7031 14.7331C24.0792 10.1461 26.4497 7.70811 28.1767 6.46364C28.4353 8.91203 29.3149 12.6065 32.1877 15.4793C32.5105 15.8021 32.8915 16.145 33.305 16.5172C35.5591 18.5462 38.7782 21.4438 38.7782 26.6668C38.7782 32.5384 33.1913 37.3335 26.3337 37.3335C19.6435 37.3335 13.8891 32.6878 13.8891 24.889C13.8891 22.3036 14.807 18.7178 15.7368 15.7864C16.0748 16.6957 16.3987 17.5951 16.647 18.34C17.1886 19.9647 18.0158 21.0853 18.7432 21.8127C19.1738 22.2433 19.6574 22.6365 20.1987 22.9202L20.202 22.9219L20.2052 22.9235Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalMembers);
export default __webpack_public_path__ + "static/media/total-members.95c854fb99f0390854ac72c0bee30801.svg";
export { ForwardRef as ReactComponent };